import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Lima'
}, {
  name: 'Rosa',
  city: 'Arequipa'
}, {
  name: 'Carmen',
  city: 'Trujillo'
}, {
  name: 'Ana',
  city: 'Cusco'
}, {
  name: 'Lucía',
  city: 'Piura'
}, {
  name: 'Patricia',
  city: 'Chiclayo'
}, {
  name: 'Gabriela',
  city: 'Huancayo'
}, {
  name: 'Sandra',
  city: 'Ica'
}, {
  name: 'Elena',
  city: 'Tacna'
}, {
  name: 'Diana',
  city: 'Cajamarca'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Stay visible for 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 5000);
    // Cycle every 10 seconds (4s visible + 6s hidden)
    const interval = setInterval(showPopup, 10000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-259">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-3 pr-6 flex items-center gap-3 max-w-[300px]" data-id="element-260">
          <div className="bg-green-100 p-1.5 rounded-full" data-id="element-261">
            <CheckCircle2 size={20} className="text-green-600" data-id="element-262" />
          </div>
          <div data-id="element-263">
            <p className="text-sm text-gray-800 leading-tight" data-id="element-264">
              <span className="font-bold" data-id="element-265">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-266">
              acaba de comprar este sistema
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}